export function getPgDisplayName(pg) {
  return `${pg.nameAcrossCountries} / ${pg.country} (${pg._id})`;
}
